import antsTheme from "./antsTheme";
import autoEcoleTheme from "./autoEcoleTheme";
import immatTheme from "./immatTheme";
import mairieTheme from "./mairieTheme";
import passeportTheme from "./passeportTheme";
import permisTheme from "./permisTheme";
import phaTheme from "./phaTheme";

export default {
  ANTS: antsTheme,
  IMMAT: immatTheme,
  PERMIS: permisTheme,
  PASSEPORT_CNI: passeportTheme,
  MAIRIE: mairieTheme,
  PHA: phaTheme,
  AUTO_ECOLE: autoEcoleTheme,
};
